import * as Yup from "yup";

export const createEvent1Schema = Yup.object().shape({
  name: Yup.string().required("Event name is required"),
  eventDate:Yup.date().required("Event date is Required"),
  coverImage:Yup.string().required('Header image is required'),
  description:Yup.string().required("Event description is Required")
});

